<template>
  <Table
    :loading="loading"
    width="100%"
    height="500"
    border
    :columns="columns"
    :data="attData"
    size="small"
    ref="table"
  >
    <template slot-scope="{ row }" slot="name">
      <span v-if="row.info">{{row.info.name}}</span>
    </template>
    <template slot-scope="{ row }" slot="notes">
      <span v-if="row.info">{{row.info.notes}}</span>
    </template>

    <template slot-scope="{ row }" slot="joinedAt">{{row.createdAt | moment("HH:mm:ss") }}</template>
    <template slot-scope="{ row }" slot="action">
      <Button
        icon="ios-mic-off"
        v-if="row.isMuted"
        shape="circle"
        @click="toggleMuteParticipant(row)"
      ></Button>
      <Button
        icon="ios-mic-outline"
        v-if="!row.isMuted"
        shape="circle"
        type="success"
        @click="toggleMuteParticipant(row)"
      ></Button>
      <Button
        icon="ios-hand-outline"
        v-if="row.handRaisedAt"
        shape="circle"
        type="success"
        @click="lowerHand(row)"
      ></Button>
      <Button icon="ios-hand-outline" v-if="!row.handRaisedAt" shape="circle"></Button>
      <Button icon="ios-close" shape="circle" @click="removeParticipant(row)"></Button>
    </template>
  </Table>
</template>

<script>
import moment from "moment";
import axios from "axios";
import $config from "@/config";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: true,
      columns: [
        { title: "Name", slot: "name", width: 240 },
        { title: "Notes", slot: "notes", width: 280 },
        { title: "CallerId", key: "callerId", width: 170 },
        { title: "Joined At", slot: "joinedAt", width: 100 },
        {
          title: "Actions",
          slot: "action",
          width: 220,
          align: "right"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("stream", {
      streamsInStore: "find"
    }),
    ...mapGetters("audio-participants", {
      participantsInStore: "find"
    }),
    attData() {
      let query = {
        isOnCall: true,
        webcastId: this.webcast._id,
        $sort: {
          handRaisedAt: -1
        }
      };

      let p = this.participantsInStore({ query: query });
      let resp = p.data;

      return resp;
    }
  },
  methods: {
    ...mapActions("stream", {
      findStreamsAction: "find"
    }),
    ...mapActions("audio-participants", {
      findParticipantsAction: "find",
      updateParticipantAction: "patch"
    }),
    lowerHand(row) {
      this.findParticipantsAction({ query: { callSid: row.callSid } }).then(
        records => {
          let p = records.data[0];
          this.updateParticipantAction([
            p._id,
            {
              isHandRaised: false,
              handRaisedAt: null
            }
          ]).then(res => {});
        }
      );
    },
    removeParticipant(p) {
      axios
        .post($config.feathersServer + "/audio/removeParticipant", {
          callSid: p.callSid,
          conferenceSid: p.conferenceSid
        })
        .then(res => {});
    },
    toggleMuteParticipant(p) {
      let nextState = true;
      if (p.isMuted) {
        nextState = false;
      } else {
        nextState = true;
      }
      axios
        .post($config.feathersServer + "/audio/toggleMuteParticipant", {
          callSid: p.callSid,
          conferenceSid: p.conferenceSid,
          isMuted: nextState
        })
        .then(res => {});
    }
  },
  created() {
    this.$store.commit("audio-participants/clearAll");
    this.findParticipantsAction({
      query: {
        webcastId: this.webcast._id
        //updatedAt: { $gte: moment(new Date()).subtract(1, "minutes").toDate().toISOString()}
      }
    }).then(() => {
      this.loading = false;
    });
  }
};
</script>

<style>
</style>
